import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appAdKpi]'
})
export class KpiDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
